<template>
  <div>
    <form-select
      :selected="selectedArr"
      :items="chooseList"
      label="Premedication (複選)"
      :column="
        data.antispasmodicHave ? 'antispasmodicID' : 'antispasmodicReason'
      "
      other-column="antispasmodicOther"
      :other-value="data.antispasmodicOther"
      @change="handleChange"
    >
      <template #header-sub>
        <p class="mb-0">Premedication (複選)</p>
        <div>
          <v-switch
            :label="hasText + '使用止痙攣藥物'"
            v-model="data.antispasmodicHave"
            @change.capture="selectUseOrNot($event)"
            hide-details
            class="py-0 mt-0"
          ></v-switch>
        </div>
      </template>
    </form-select>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import formSelect from './form-select.vue'

export default {
  name: 'AntispasmodicInput',
  components: {
    formSelect,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      hasText: '無',
      selected: this.data.antispasmodicIDs,
      reasonSelected: this.data.antispasmodicReason,
      othersSelected: false,
    }
  },

  computed: {
    ...mapGetters('examinations', [
      'getAntispasmodicList',
      'getNoUseAntipasmodicReasonList',
    ]),
    getUseReasons() {
      return this.getAntispasmodicList
        .map((item) => ({ text: item.antispasmodic, value: item.id }))
        .concat({ text: '其他', value: this.getAntispasmodicList.length + 1 })
    },
    getNoUseReasons() {
      return this.getNoUseAntipasmodicReasonList.concat({
        text: '其他',
        value: this.getNoUseAntipasmodicReasonList.length + 1,
      })
    },
    selectedArr: {
      get() {
        return this.data.antispasmodicHave ? this.selected : this.reasonSelected
      },
      set(val) {
        if (this.data.antispasmodicHave) {
          this.selected = [...val]
        } else {
          this.reasonSelected = [...val]
        }
        console.log(val)
      },
    },
    chooseList() {
      return this.data.antispasmodicHave
        ? this.getUseReasons
        : this.getNoUseReasons
    },
  },
  methods: {
    selectOther(value) {
      this.$emit('change', { field: 'antispasmodicOther', event: value })
      this.othersSelected = value && value.length > 0
    },
    selectNotUse() {
      this.$emit('change', {
        field: 'antispasmodicReason',
        event: this.reasonSelected.join(','),
      })
    },
    selectUse() {
      this.$emit('change', {
        field: 'antispasmodicID',
        event: this.selected.join(','),
      })
    },
    selectUseOrNot(value) {
      this.hasText = value ? '有' : '無'
      this.$emit('change', { field: 'antispasmodicHave', event: value })
    },
    handleChange(column, value) {
      if (!column) return
      if (column === 'antispasmodicOther') {
        this.selectOther(value)
      } else {
        if (this.data.antispasmodicHave) {
          this.selectedArr = value
          this.selectUse()
        } else {
          this.selectedArr = value
          this.selectNotUse()
        }
      }
    },
  },
  mounted() {
    if (this.data.antispasmodicHave == null) {
      this.selectUseOrNot(false)
    } else {
      this.hasText = this.data.antispasmodicHave ? '有' : '無'
    }
    this.othersSelected =
      this.data.antispasmodicOther && this.data.antispasmodicOther.length > 0
  },
}
</script>
